import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-maskedinput';
import classNames from 'classnames';
import { IconPencil, IconWarningSign } from '../Icons';

export default class TextInput extends Component {
  componentName = 'TextInput';
  static propTypes = {
    /** input type element: text, hidden or password */
    type: PropTypes.string,
    /** name of the element */
    name: PropTypes.string,
    /** id of the element */
    id: PropTypes.string,
    /** The value of the element */
    value: PropTypes.string,
    /** On Value empty, place this string as a placeholder */
    placeholder: PropTypes.string,
    /** input mask to render masked input */
    mask: PropTypes.string,
    /** True will render component like a label. False will render as input control */
    asLabel: PropTypes.bool,
    /** True will toggle the control on focus and blur */
    togglable: PropTypes.bool,
    /** Boolean indicating whether it should render as disabled */
    disabled: PropTypes.bool,
    /** Errormessage and indicator if element should render in error state */
    error: PropTypes.string,
    /** Handle onChange events */
    onChange: PropTypes.func,
    /** Handle onFocus events */
    onFocus: PropTypes.func,
    /** Handle onBlur events */
    onBlur: PropTypes.func,
  };

  static defaultProps = {
    type: 'text',
    name: undefined,
    id: undefined,
    value: undefined,
    placeholder: undefined,
    mask: undefined,
    asLabel: false,
    togglable: false,
    disabled: false,
    error: undefined,
    onChange: () => {},
    onFocus: () => {},
    onBlur: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      asLabel: props.togglable ? true : props.asLabel,
    };
  }
  handleBlur = event => {
    const { onBlur, asLabel, error, togglable } = this.props;
    if (error) {
      // When there is an error set focus back to input
      event.target.focus();
      return;
    }
    this.setState(state => ({
      ...state,
      asLabel: togglable ? true : asLabel,
    }));
    onBlur(event);
  };

  handleFocus = event => {
    const { onFocus, asLabel, onChange, togglable } = this.props;
    this.setState(state => ({
      ...state,
      asLabel: togglable ? false : asLabel,
    }));
    onChange(event);
    onFocus(event);
  };

  renderInput() {
    const { asLabel } = this.state;
    const { togglable, ...rest } = this.props;
    const readOnly = asLabel; // if rendered as label. Set readOnly also to true
    const className = classNames({
      'TextInput--readOnly': asLabel,
      'form-control TextInput--edit': !asLabel,
      'TextInput--editable': togglable && asLabel,
    });

    const propsContainer = {
      className,
      ...rest,
      readOnly,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      ref: input => {
        this.inputElement = input;
      },
    };
    return rest.mask ? (
      <MaskedInput {...propsContainer} />
    ) : (
      <input data-1p-ignore autoComplete="off" {...propsContainer} />
    );
  }

  componentDidUpdate(prevProps) {
    const { error } = this.props;
    if (prevProps.error !== error && error) {
      this.inputElement.focus();
    }
  }

  render() {
    const { error, value, togglable, placeholder, mask, type } = this.props;
    const { asLabel } = this.state;
    const classname = classNames({
      'form-group': true,
      'has-error has-feedback': error,
      'has-feedback': !value,
    });
    const isHidden = type === 'hidden';
    const iconClass = 'form-control-feedback';
    return (
      <div className={classname} title={error}>
        {this.renderInput()}
        {error && !isHidden && <IconWarningSign className={iconClass} />}
        {!value && !error && togglable && !placeholder && !mask && asLabel && !isHidden && (
          <IconPencil className={iconClass} />
        )}
      </div>
    );
  }
}
